import Radio from '@material-ui/core/Radio';

/** @deprecated Exporting the Radio component from the @material-ui/core/Radio module. */
export default Radio;
